import { request } from "utils/request";
import { AxiosPromise } from "axios";


export const productRateApi = {
  findAll: (params?: any): AxiosPromise<any> => request({
    url: '/v1/admin/productRate',
    params
  }),
  create: (data: any): AxiosPromise<any> => request({
    url: '/v1/admin/productRate',
    data,
    method: 'post'
  }),
  update: (id: number, data: any): AxiosPromise<any> => request({
    url: `/v1/admin/productRate/${id}`,
    method: 'patch',
    data
  }),
  delete: (id: number): AxiosPromise<any> => request({
    url: `/v1/admin/productRate/${id}`,
    method: 'delete'
  }),
}
